<template>
  <dashboard>
    <template v-slot:content>
      <section>
        <b-container fluid>
          <div class="header-elements my-2 align-items-center">
            <b-row class="mt-2">
              <b-col lg="6" md="6">
                <b-row class="mt-1 align-items-center">
                  <b-col lg="7" md="7">
                    <div class="mt-1 d-flex align-items-baseline">
                      <h5
                        v-if="!state.system.isOffline"
                        v-text="Title"
                        @click="$store.commit('billing/newBilling')"
                      />
                      <h5 v-else v-text="OfflineTitle"></h5>
                      <div class="total-amount d-flex ml-1">
                        <span
                          class="quantity h5 mb-0 mr-1"
                          v-text="`(${state.billing.billing.total_qty})`"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="5" md="5" class="cart-mode">
                    <b-tabs
                      v-model="billingModeIndex"
                      pills
                      card
                      class="float-right"
                      @activate-tab="billingModeToggle"
                    >
                      <b-tab
                        :title="item"
                        v-for="(item, index) in tabOptions"
                        :key="index"
                        :ref="item"
                      />
                    </b-tabs>
                    <b-modal
                      ref="switch-mode"
                      id="switch-mode"
                      size="sm"
                      hide-footer
                      hide-header
                      centered
                      no-close-on-backdrop
                      no-close-on-esc
                    >
                      <p class="fs-14 d-flex title">
                        <img
                          src="../assets/images/icon_notif.svg"
                          alt
                          class="mr-2"
                        />
                        <span v-if="modeData.new == 0">Billing Mode</span>
                        <span v-if="modeData.new == 1">Return Mode</span>
                        <span v-if="modeData.new == 2">Order Mode</span>
                      </p>
                      <p class="pt-2" v-if="modeData.new == 0">
                        Are you sure you wish to switch to billing mode?
                      </p>
                      <p class="pt-2" v-if="modeData.new == 1">
                        Are you sure you wish to switch to return mode?
                      </p>
                      <p class="pt-2" v-if="modeData.new == 2">
                        Are you sure you wish to switch to order mode?
                      </p>

                      <div class="d-flex pt-3">
                        <b-button
                          class="mr-1"
                          block
                          variant="outline-primary"
                          @click="
                            $refs['switch-mode'].hide(),
                              (modeData = { new: 0, old: 0 })
                          "
                          id="switch-mode-cancel"
                        >
                          Cancel
                        </b-button>
                        <b-button
                          variant="primary"
                          block
                          class="ml-1"
                          @click="billingModeToggle(), offlineCartHandler()"
                          id="switch-mode-confirm"
                        >
                          Confirm
                        </b-button>
                      </div>
                    </b-modal>
                    <!-- <div class="total-items d-flex justify-content-between float-right">
                      <div class="d-flex ml-2" v-if="state.system.isOffline == false">
                        Return Mode
                        <toggle-button
                          :width="40"
                          @change="onChangeEventHandler"
                          :labels="false"
                          :sync="true"
                          :value="state.billing.billing.refund_mode"
                        />
                      </div>
                    </div>-->
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="6" md="6">
                <!-- Catalog Search-->
                <catalog-search
                  v-on:show-cat="contentShow"
                  showButtonText="View Catalog"
                  hideButtonText="Hide Catalog"
                  :btnDisabled="checkCatlog"
                  :isScan="true"
                  :isSearch="true"
                />
                <!-- placeholder="Enter Barcode or Search Product" -->
                <!-- Catalog Search End-->
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <b-row>
            <!-- Cart Table -->
            <b-col lg="6" md="6" class="pr-0 fadein">
              <div class="box-shadow">
                <cart-table
                  @get-product-info="showProductInfo"
                  v-bind:salesPersonSelected="salesPersonSelected"
                  v-on:hide-salesp="salehide"
                  :isHide="isHide"
                  :isContentShow="isContentShow"
                />
              </div>
            </b-col>
            <b-col lg="6" md="6" class="fadein" v-show="isVisible">
              <sales-person
                v-on:hide-salesp="salehide"
                @selected-sale-person="salePersonAssigned"
                :isVisible="isVisible"
              />
              <b-row class="mt-2">
                <b-col md="6" lg="6">
                  <session-information />
                </b-col>
                <b-col md="6" lg="6" class="pl-0">
                  <div class="card mb-2 total-cart-amount box-shadow">
                    <div class="card-body p-0">
                      <div class="row sale align-items-center">
                        <div class="col light">
                          <p>Payable Amount</p>
                        </div>
                        <div class="col text-right">
                          <h6
                            class="mb-0"
                            v-text="
                              currencySymbol +
                                state.billing.billing.total_payable
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <action-btns v-on:hide-salesp="salehide" />
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6" md="6" v-show="isHide" class="fadein">
              <div class="product-detail-wrapper">
                <category-buttons v-on:show-salesp="saleShow" />
              </div>
              <div class="clearfix"></div>

              <!-- Product information-->
              <product-information v-show="isHide" :data="productDetails" />
              <!-- Product information close-->

              <b-row class="mt-2" v-show="isHide">
                <b-col md="6" lg="6">
                  <session-information />
                  <customer-information />
                </b-col>

                <b-col md="6" lg="6" class="pl-0">
                  <cart-total />
                  <action-btns v-on:hide-salesp="salehide" />
                </b-col>
              </b-row>
            </b-col>

            <b-col md="6" lg="6" v-show="isContentShow" class="fadein">
              <div class="product-catalog-wrapper">
                <product-catalog :is-display="isContentShow" />
                <b-row class="mt-2">
                  <b-col md="6" lg="6">
                    <!-- <session-information /> -->
                    <customer-information />
                  </b-col>
                  <b-col md="6" lg="6" class="pl-0">
                    <div class="card mb-2 total-cart-amount box-shadow">
                      <div class="card-body">
                        <div class="row">
                          <div class="col light">
                            <p>Payable Amount</p>
                          </div>
                          <div class="col text-right">
                            <h6
                              class="mb-0"
                              v-text="
                                currencySymbol +
                                  formatAmount(
                                    state.billing.billing.total_payable
                                  )
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <action-btns v-on:hide-salesp="salehide" />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <!-- Session Modal Box -->

      <!-- <session-modal-box :open="isSessionBoxOpen"></session-modal-box>-->
      <keyboard-shortcut-modal
        :openShortcuts="openShortcuts"
        @hide="hideKeyboardModal"
        v-shortkey="['ctrl', 'alt', 'k']"
        @shortkey.native="openKeyboardModal"
      />
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import CatalogSearch from "../components/CatalogSearch";
import CartTable from "../components/CartTable";
import ActionBtns from "../components/ActionBtns";
import CategoryButtons from "../components/CategoryButtons";
import ProductInformation from "../components/ProductInfomration";
import SessionInformation from "../components/SessionInformation";
import CustomerInformation from "../components/CustomerInformation";
import CartTotal from "../components/CartTotal";
import ProductCatalog from "../components/ProductCatalog";
import { library } from "@fortawesome/fontawesome-svg-core";
import SalesPerson from "../components/SalesPerson";
import KeyboardShortcutModal from "../components/KeyboardShortcutModal";
import * as helper from "../helper";

import {
  faSearch,
  faSearchPlus,
  faRedo,
  faTimes,
  faExternalLinkAlt,
  faPlus,
  faPen,
  faExclamationCircle,
  faCircleNotch,
  faPlusCircle,
  faMinusCircle,
  faEdit,
  faPencilAlt,
  faKeyboard,
  faUpload,
  faCheck,
  faMinus,
  faAngleRight,
  faAngleUp,
  faAngleDown,
  faSync,
  faBars,
  faTh,
  faExchangeAlt,
  faCamera,
  faCalendarAlt,
  faInfoCircle,
  faEye,
  faEyeSlash,
  faPhone,
  faBarcode,
  faTrashAlt,
  faList,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { mapState } from "vuex";

library.add(
  faSearch,
  faSearchPlus,
  faRedo,
  faTimes,
  faExternalLinkAlt,
  faPlus,
  faPen,
  faExclamationCircle,
  faCircleNotch,
  faPlusCircle,
  faMinusCircle,
  faEdit,
  faPencilAlt,
  faKeyboard,
  faUpload,
  faCheck,
  faMinus,
  faAngleRight,
  faAngleDown,
  faAngleUp,
  faSync,
  faBars,
  faTh,
  faExchangeAlt,
  faCamera,
  faCalendarAlt,
  faInfoCircle,
  faEyeSlash,
  faEye,
  faPhone,
  faBarcode,
  faTrashAlt,
  faList,
  faUser
);

export default {
  name: "billing",
  components: {
    Dashboard,
    CatalogSearch,
    CartTable,
    CategoryButtons,
    ActionBtns,
    ProductInformation,
    SessionInformation,
    CustomerInformation,
    CartTotal,
    ProductCatalog,
    SalesPerson,
    KeyboardShortcutModal,
  },
  props: ["newValue", "salesPerson"],
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    checkCatlog() {
      if (this.state.system.is_catalog == 1) {
        return false;
      } else {
        return true;
      }
    },
    globalLoading() {
      return this.state.sessions.loading;
    },
    tabOptions() {
      let temp = [];
      if (!this.state.system.isOffline) {
        temp.push("Billing");
        if (this.allowAdhocReturn) temp.push("Return");
        if (this.$store.getters.isOMSEnabled) temp.push("Order");
      } else temp.push("Billing");
      return temp;
    },
    allowAdhocReturn() {
      return this.state.system.settings.cart.allow_adhoc_return.status == 1
        ? true
        : false;
    },
    // showMessage() {
    //   if (this.state.isMsg != "") {
    //     console.log("Show Message");
    //   }
    // }
  },
  watch: {
    globalLoading() {
      if (this.state.sessions.loading == true) {
        this.$loading = true;
      } else {
        this.$loading = false;
      }
    },
  },
  mounted() {
    this.getSettings();
    this.settlementData();
    console.log(process.env.VUE_APP_API_URL);
    this.switchToOnline();
    let billingModeArrayList = { normal: 0, return: 1, order: 2 };
    this.modeData.new =
      billingModeArrayList[this.state.billing.billing.billing_mode] == undefined
        ? 0
        : billingModeArrayList[this.state.billing.billing.billing_mode];
    this.$store.commit("billing/setTransactionSubType", "");
    this.billingModeToggle();
  },
  data() {
    return {
      Title: "Cart",
      OfflineTitle: "Offline Cart",
      NumOfItems: 0,
      isContentShow: false,
      amount: 0,
      isVisible: false,
      isShow: false,
      isPay: false,
      isHide: true,
      isSessionBoxOpen: false,
      productDetails: "",
      salesPersonSelected: "",
      openShortcuts: false,
      billingModeIndex: 0,
      modeData: {
        new: 0,
        old: 0,
      },
    };
  },
  methods: {
    switchToOnline() {
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        if (
          (this.state.system.forceOffline == true &&
            this.state.billing.billing.cart == "") ||
          (this.state.system.forceOffline == true &&
            this.state.billing.billing.cart.data.length == 0)
        ) {
          console.log("fire");
          this.$store.commit("system/forceOfflineStatus", false);
          this.$store.commit("system/setConnected", false);
          helper.syncApiToken();
        }
      }
    },
    settlementData() {
      if (this.$store.state.sessions.session.required == 1) {
        this.isSessionBoxOpen = true;
      }
    },
    contentShow() {
      if (this.isContentShow == false) {
        this.isContentShow = true;
        this.isVisible = false;
        this.isHide = false;
      } else {
        this.isContentShow = false;
        this.isHide = true;
        this.isVisible = false;
      }
    },
    errorCaptured(err, vm, info) {
      console.log("error captured in component", vm);
      console.error(err);
      console.log("error info:", info);
    },
    saleShow() {
      this.isVisible = true;
      this.isHide = false;
      this.isContentShow = false;
    },
    salehide() {
      this.isVisible = false;
      this.isHide = true;
    },
    getSettings() {
      Object.keys(this.state.system.settings).map((item) => {
        if (item == "settlement") {
          // self.settlement(this.state.settings[item]);
        }
      });
      this.state.system.last_setting_invoked = this.$moment().format(
        "MMMM Do YYYY, h:mm:ss a"
      );
    },
    saveDenomination(data) {
      this.session.openingAmount = 0;
      this.session.denomination.map((item) => {
        if (item.amount == data.currency) {
          item.value = data.value;
        }
        this.session.openingAmount += item.value;
      });
    },
    showProductInfo(data) {
      this.productDetails = data;
    },
    salePersonAssigned(data) {
      this.salesPersonSelected = data;
    },
    openKeyboardModal() {
      this.openShortcuts = true;
    },
    hideKeyboardModal() {
      this.openShortcuts = false;
    },
    billingModeToggle(newTabIndex, oldTabIndex, bvEvt) {
      if (
        typeof newTabIndex == "number" &&
        (this.modeData.new != newTabIndex || this.modeData.old != oldTabIndex)
      ) {
        this.billingModeIndex = oldTabIndex;
        this.modeData = {
          new: newTabIndex,
          old: oldTabIndex,
        };
        bvEvt.preventDefault();
        this.$refs["switch-mode"].show();
      }
      if (bvEvt == undefined) {
        this.billingModeIndex = this.modeData.new;
        let billingSettingArray = ["normal", "return", "order"];
        this.$store.commit(
          "billing/setBillingMode",
          billingSettingArray[this.billingModeIndex]
        );
        this.$refs["switch-mode"].hide();
      }
    },
    offlineCartHandler() {
      if (
        this.state.billing.billing.cart.hasOwnProperty("data") &&
        this.state.billing.billing.cart.data.length == 0
      )
        return;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 0
      )
        return;
      if (this.billingModeIndex != 0) helper.clearOfflineCart();
      else this.$store.dispatch("billing/cartDetails");
    },
  },
};
</script>
<style lang="scss" scoped>
@include keyframes(fadein) {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadein {
  @include animation("fadein 1s");
}
@include keyframes(fadeout) {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeout {
  @include animation("fadeout 1s");
}

.open-session {
  form {
    .form-group {
      margin-bottom: 10px;
    }
    input {
      height: 40px;
    }
  }
}
.header-elements {
  .total-amount {
    color: #404040;
    .quantity {
      font-size: 1.2rem;
      margin-top: -2px;
    }
  }
}
.theme-dark .header-elements {
  .total-amount {
    color: #c0c0c0;
    span {
      font-size: 1.2rem;
      margin-top: -2px;
    }
  }
}
.return-mode {
  display: none !important;
}
.product-catalog-wrapper .total-cart-amount .card-body {
  padding: 2rem 0.75rem;
}
.sale {
  padding: 2rem 0.75rem;
}
.total-cart-amount p {
  font-size: 0.7125rem !important;
  margin: 4px 0px;
}
.vue-js-switch {
  margin: 0;
  margin-left: 7px;
}
</style>
